import { createContext, useContext, useState, useMemo } from "react";
import en from "./en";
import es from "./es";
import de from "./de";
import it from "./it";
import fr from "./fr";

export const LANGS = [
  { code: "en", label: "English", flag: "gb" },
  { code: "es", label: "Español", flag: "es" },
  { code: "de", label: "Deutsch", flag: "de" },
  { code: "it", label: "Italiano", flag: "it" },
  { code: "fr", label: "Français", flag: "fr" },
];

const DICT = { en, es, de, it, fr };
const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const value = useMemo(() => {
    const t = DICT[lang];
    const money = (n) => new Intl.NumberFormat(lang, { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
    const longDate = (iso) => new Intl.DateTimeFormat(lang, { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(new Date(iso + "T12:00:00"));
    const shortDate = (iso) => new Intl.DateTimeFormat(lang, { weekday: "short", day: "numeric", month: "short" }).format(new Date(iso + "T12:00:00"));
    return { lang, setLang, t, money, longDate, shortDate };
  }, [lang]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
